import { SwiperOptions } from 'swiper/types'

export const swiperOptions: SwiperOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 500,
  effect: 'slide',
  resistance: true,
  resistanceRatio: 0.85
}
